function showSizes(region) {
    var variants = document.querySelectorAll('.product-variant');
    for (var i = 0; i < variants.length; i++) {
      variants[i].style.display = 'none';
    }
    var selectedVariants = document.querySelectorAll('.' + region + '-size');
    for (var i = 0; i < selectedVariants.length; i++) {
      selectedVariants[i].style.display = 'inline';
    }
  }
  document.addEventListener("DOMContentLoaded", function() {
    function showSizePopupMobile() {
        let popupOpen = document.querySelectorAll('.mobile-size-hover__toggle-container');
        let popupMobiles = document.querySelectorAll('.product-variants-container');
        let activeIndex = -1; 

        if (popupOpen.length > 0 && popupMobiles.length > 0 && popupOpen.length === popupMobiles.length) {
            for (let i = 0; i < popupOpen.length; i++) {
                popupOpen[i].addEventListener("click", (event) => {
                    event.stopPropagation(); // Prevent event from propagating to document.body
                    if (activeIndex !== -1 && activeIndex !== i) {
                        popupMobiles[activeIndex].classList.remove('active'); 
                        popupOpen[activeIndex].style.display = 'block'; 
                    }
                    popupMobiles[i].classList.add('active'); 
                    popupOpen[i].style.display = 'none'; // Hide popupOpen when popupMobiles is active
                    activeIndex = i; 
                });
            }

            document.body.addEventListener("click", (event) => {
                for (let i = 0; i < popupMobiles.length; i++) {
                    if (!popupMobiles[i].contains(event.target) && !popupOpen[i].contains(event.target)) {
                        popupMobiles[i].classList.remove('active');
                        popupOpen[i].style.display = 'block'; 
                        activeIndex = -1; 
                    }
                }
            });

            window.addEventListener("scroll", () => {
                for (let i = 0; i < popupMobiles.length; i++) {
                    popupMobiles[i].classList.remove('active');
                    popupOpen[i].style.display = 'block'; 
                    activeIndex = -1; 
                }
            });
        } else {
            console.log('Elements not found or number of toggles and mobiles mismatched');
        }
    }

    showSizePopupMobile();
});


var sizeTabsContainers = document.querySelectorAll('.size-tabs');

sizeTabsContainers.forEach(function(container) {
    var tabs = container.querySelectorAll('.tab');

    tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {

            tabs.forEach(function(tab) {
                tab.classList.remove('active');
            });


            tab.classList.add('active');
        });
    });
});









